export default "__VITE_ASSET__d0df6345__"